import { bind, wire } from 'hyperhtml/umd';

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
};

var createClass = (function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ('value' in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends =
  Object.assign ||
  function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

var get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ('value' in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError(
      'Super expression must either be null or a function, not ' +
        typeof superClass
    );
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true,
    },
  });
  if (superClass)
    Object.setPrototypeOf
      ? Object.setPrototypeOf(subClass, superClass)
      : (subClass.__proto__ = superClass);
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError(
      "this hasn't been initialised - super() hasn't been called"
    );
  }

  return call && (typeof call === 'object' || typeof call === 'function')
    ? call
    : self;
};

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(
    Object.defineProperties(strings, {
      raw: {
        value: Object.freeze(raw),
      },
    })
  );
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++)
      arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

function _CustomElement() {
  return Reflect.construct(HTMLElement, [], this.__proto__.constructor);
}
Object.setPrototypeOf(_CustomElement.prototype, HTMLElement.prototype);
Object.setPrototypeOf(_CustomElement, HTMLElement);
// Dummy class necessary to give `babel-transform-custom-element-classes`
// something to operate on, producing es5-compatible code.
var _HTMLElement = (function (_CustomElement2) {
  inherits(_HTMLElement, _CustomElement2);

  function _HTMLElement() {
    classCallCheck(this, _HTMLElement);
    return possibleConstructorReturn(
      this,
      (_HTMLElement.__proto__ || Object.getPrototypeOf(_HTMLElement)).apply(
        this,
        arguments
      )
    );
  }

  return _HTMLElement;
})(_CustomElement);

var HAS_SHADY_CSS = window.hasOwnProperty('ShadyCSS');

function createTemplate(html) {
  var template = document.createElement('template');
  template.innerHTML = html;
  return template;
}

/**
 *
 * @param {String[]} props A list of property names.
 * @param {Object} [source] A source of initial values.
 * @returns {Object} Object with a key for each property name and value
 * corresponding to the same key in the source object (or `undefined`).
 *
 * @ignore (Hide from generated docs)
 */
function initializeProps(props) {
  var source =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return props.reduce(function (_props, prop) {
    return _extends({}, _props, defineProperty({}, prop, source[prop]));
  }, {});
}

/**
 * Automatically reflects related properties and attributes. Attributes listed
 * in `reflectedAttributes` will be synced between props with the same name.
 *
 * Boolean attributes can be defined as well by setting `boolean` to true in the
 * Attribute descriptor.
 *
 * @category mixin
 * @param {Class} [Base=HTMLElement] Optional base class to extend from.
 * @returns {Class}
 *
 * @example
 ```js
import { withAttributeReflection } from '@updater-legacy/components/custom-element';

class MyCustomElement extends withAttributeReflection() {
  // Define attributes as normal
  static get observedAttributes() {
    return ['name', 'disabled', 'value'];
  }

  static get reflectedAttributes() {
    return [
      {
        name: 'name',
      },
      {
        name: 'disabled',
        boolean: true,
      }
    ]
  }
  
  // They are reflected as if you had used getters and setters:
  // get name() {
  //   return this.getAttribute('name');
  // }

  // set name(value) {
  //   this.setAttribute('name', value);
  // }
}
 ```
 */

var withAttributeReflection = function withAttributeReflection() {
  var Base =
    arguments.length > 0 && arguments[0] !== undefined
      ? arguments[0]
      : _HTMLElement;
  return (function (_Base) {
    inherits(_class, _Base);

    function _class() {
      classCallCheck(this, _class);

      var _this = possibleConstructorReturn(
        this,
        (_class.__proto__ || Object.getPrototypeOf(_class)).call(this)
      );

      var reflectedAttrs = (_this.constructor.reflectedAttributes || []).map(
        function (attr) {
          return _extends({}, attr, { name: kebabToCamelCase(attr.name) });
        }
      );
      _this._initialReflectedAttrs = initializeProps(
        reflectedAttrs.map(function (attr) {
          return attr.name;
        }),
        _this
      );
      var setBooleanAttribute = function setBooleanAttribute(name) {
        return function (value) {
          return value
            ? _this.setAttribute(name, '')
            : _this.removeAttribute(name);
        };
      };

      reflectedAttrs.forEach(function (_ref) {
        var name = _ref.name,
          _ref$boolean = _ref.boolean,
          boolean = _ref$boolean === undefined ? false : _ref$boolean;

        if (_this.hasOwnProperty(name)) {
          delete _this[name];
        }

        Object.defineProperty(_this, name, {
          enumerable: true,
          get: boolean
            ? function () {
                return _this.hasAttribute(name);
              }
            : function () {
                return _this.getAttribute(name);
              },
          set: boolean
            ? setBooleanAttribute(name)
            : function (newVal) {
                return _this.setAttribute(name, newVal);
              },
        });
      });
      return _this;
    }

    createClass(_class, [
      {
        key: 'connectedCallback',
        value: function connectedCallback() {
          var _this2 = this;

          get(
            _class.prototype.__proto__ ||
              Object.getPrototypeOf(_class.prototype),
            'connectedCallback',
            this
          ) &&
            get(
              _class.prototype.__proto__ ||
                Object.getPrototypeOf(_class.prototype),
              'connectedCallback',
              this
            ).call(this);

          // Apply "upgradeProperty" workaround. While these are attributes we are
          // allowing users to set them as properties and if the related
          // properties are set before this constructor is called the setter won't
          // be called like we want it to be. We need to do this here because it
          // is speced that constructors must not add attributes.
          // https://developers.google.com/web/fundamentals/web-components/best-practices#lazy-properties
          // https://www.w3.org/TR/custom-elements/#custom-element-conformance
          if (this._initialReflectedAttrs) {
            Object.keys(this._initialReflectedAttrs).forEach(function (attr) {
              if (_this2._initialReflectedAttrs[attr] != undefined) {
                _this2[attr] = _this2._initialReflectedAttrs[attr];
              }
            });
          }

          // We only want to do this once otherwise if this is connected then
          // disconnected all the attrs would be reset.
          delete this._initialReflectedAttrs;
        },
      },
    ]);
    return _class;
  })(Base);
};

var kebabToCamelCase = function kebabToCamelCase(string) {
  return string.replace(/(-[a-z])/g, function (letters) {
    return letters[1].toUpperCase();
  });
};

/**
 * Provides `connected` and `disconnected` callback alternatives to `connectedCallback` and `disconnectedCallback`, respectively.
 *
 * Many mixins override `connectedCallback` and `disconnectedCallback` to apply their behaviors. When consumers of such mixins make use of those hooks, they are required to first call `super` or otherwise lose whatever work the mixin(s) would perform.
 *
 * By providing the `connected` and `disconnected` callback alternatives, classes that extend from mixins won't need to worry about the complexity introduced in these callbacks by the mixins.
 *
 * [Partially lifted from SkateJS.](https://github.com/skatejs/skatejs/blob/5246f85abc166b8ffec3e87ce9c5775c425baf5a/packages/skatejs/src/with-lifecycle.js)
 * @category mixin
 * @param {Class} [Base=HTMLElement] Optional base class to extend from.
 * @returns {Class}
 * @example
   ```js
  import { withLifecycle } from '@updater-legacy/components/custom-element';

  class MyCustomElement extends withLifecycle() {
    connectedCallback() {
      // While flexible, being able to execute code prior to the `super` call
      // may introduce unexpected behavior when paired with mixins since they
      // need to make assumptions about order of operations.
      super.connectedCallback(); // Boilerplate-y and error-prone.
    }

    connected() {
      // No need to worry about order of operations or about calling `super`!
    }
  }
```
 */
var withLifecycle = function withLifecycle() {
  var Base =
    arguments.length > 0 && arguments[0] !== undefined
      ? arguments[0]
      : _HTMLElement;
  return (function (_Base) {
    inherits(_class, _Base);

    function _class() {
      classCallCheck(this, _class);
      return possibleConstructorReturn(
        this,
        (_class.__proto__ || Object.getPrototypeOf(_class)).apply(
          this,
          arguments
        )
      );
    }

    createClass(_class, [
      {
        key: 'connectedCallback',
        value: function connectedCallback() {
          get(
            _class.prototype.__proto__ ||
              Object.getPrototypeOf(_class.prototype),
            'connectedCallback',
            this
          ) &&
            get(
              _class.prototype.__proto__ ||
                Object.getPrototypeOf(_class.prototype),
              'connectedCallback',
              this
            ).call(this);
          this.connected && this.connected();
        },
      },
      {
        key: 'disconnectedCallback',
        value: function disconnectedCallback() {
          get(
            _class.prototype.__proto__ ||
              Object.getPrototypeOf(_class.prototype),
            'disconnectedCallback',
            this
          ) &&
            get(
              _class.prototype.__proto__ ||
                Object.getPrototypeOf(_class.prototype),
              'disconnectedCallback',
              this
            ).call(this);
          this.disconnected && this.disconnected();
        },
      },
    ]);
    return _class;
  })(Base);
};

var IS_IE11 = !!window.MSInputMethodContext && !!document.documentMode;

/**
 * Applies workarounds and shimming necessary to make ShadowDOM work across browsers that don't support it (see `browserslist` for list of supported browsers).
 *
 * Each element instance has a ShadowDOM attached and receives a `_styles` private property with shimmed, ready-to-mount styles.
 *
 * @category mixin
 * @param {String} styles CSS string to shim for ShadowDOM use.
 * @param {Class} [Base=HTMLElement] Optional base class to extend from.
 * @returns {Class}
 *
 * @example
```js
import { withShadowDOM } from '@updater-legacy/components/custom-element';
import styles from './index.css';

class MyCustomElement extends withShadowDOM(styles)() {
  constructor() {
    super();
    this.shadowRoot.appendChild(this._styles);
  }
}
 ```
 */
var withShadowDOM = function withShadowDOM(styles) {
  return function () {
    var Base =
      arguments.length > 0 && arguments[0] !== undefined
        ? arguments[0]
        : _HTMLElement;
    return (function (_Base) {
      inherits(_class, _Base);

      function _class() {
        classCallCheck(this, _class);

        var _this = possibleConstructorReturn(
          this,
          (_class.__proto__ || Object.getPrototypeOf(_class)).call(this)
        );

        _this.attachShadow({ mode: 'open' });

        if (!_this.constructor._styles) {
          _this.constructor._styles = shimStyles(_this.localName, styles);
        }

        _this._styles = _this.constructor._styles.content.cloneNode(true);
        return _this;
      }

      createClass(_class, [
        {
          key: 'connectedCallback',
          value: function connectedCallback() {
            get(
              _class.prototype.__proto__ ||
                Object.getPrototypeOf(_class.prototype),
              'connectedCallback',
              this
            ) &&
              get(
                _class.prototype.__proto__ ||
                  Object.getPrototypeOf(_class.prototype),
                'connectedCallback',
                this
              ).call(this);

            if (HAS_SHADY_CSS) {
              // ShadyCSS prescribes making this call here. We're not entirely sure
              // why or what it does. https://github.com/webcomponents/shadycss#usage
              window.ShadyCSS.styleElement(this);
            }
          },
        },
      ]);
      return _class;
    })(Base);
  };
};

/**
 * Utility function that handles ShadyCSS styling quirks.
 * While we're polyfilling, any CSS used with ShadowDOM need to pass through
 * this function.
 *
 * @param {String} tagName The custom element's tag name.
 * @param {String} styles CSS to be scoped to the ShadowDOM.
 * @returns {HTMLTemplateElement} Either a template element that contains
 * the styles (no shimming, native ShadowDOM) or an empty template with
 * the styles extracted to the document head (shimming, no native ShadowDOM).
 *
 * @ignore (Hide from generated docs)
 */
function shimStyles(tagName, styles) {
  if (IS_IE11) {
    // For some reason, `ShadyCSS.prepareTemplate` doesn't work in IE11 when
    // the styles include CSS variables, even w/ `shimcssproperties: false`.
    // As a workaround/trade-off, we simply strip CSS variables from IE11 styles.
    styles = styles.replace(/var\(--[\w-]+\)/gm, '');
  }

  var template = createTemplate('<style>' + styles + '</style>');

  if (HAS_SHADY_CSS) {
    // Internally, this is a no-op if the browser supports ShadowDOM.
    // If the browser doesn't support ShadowDOM, the styles are extracted
    // from the template to the document head and scoped to the component.
    window.ShadyCSS.prepareTemplate(template, tagName);
  }

  return template;
}

/**
 * Defines an HTML template to use with all instances of the resulting class.
 *
 * @category mixin
 * @param {String} html HTML string that's cloned into a DOM node for each class instance, available through the private member `this._template`.
 * @param {Class} [Base=HTMLElement] Optional base class to extend from.
 * @returns {Class}
 * @example
 ```js
import { withTemplate } from '@updater-legacy/components/custom-element';
import html from './index.html';

class MyCustomElement extends withTemplate(html)() {
  constructor() {
    super();
    this.appendChild(this._template);
  }
}
```
 */
var withTemplate = function withTemplate(html) {
  return function () {
    var Base =
      arguments.length > 0 && arguments[0] !== undefined
        ? arguments[0]
        : _HTMLElement;

    return (function (_Base) {
      inherits(_class, _Base);

      function _class() {
        classCallCheck(this, _class);

        var _this = possibleConstructorReturn(
          this,
          (_class.__proto__ || Object.getPrototypeOf(_class)).call(this)
        );

        if (!_this.constructor._template) {
          var template = createTemplate(html);

          if (HAS_SHADY_CSS) {
            // Scope styles to support ShadowDOM (out of scope for this mixin).
            // ShadyCSS handles this automagically for DOM that's added async
            // (via MutationObserver), but not for DOM that's added sync.
            // TODO: Figure out better solution.
            window.ShadyCSS.prepareTemplate(template, _this.localName);
          }

          _this.constructor._template = template;
        }

        _this._template = _this.constructor._template.content.cloneNode(true);
        return _this;
      }

      return _class;
    })(Base);
  };
};

/**
 * Manages changes to a component's inner and outer state by monitoring both
 * props and attributes and calling `updated` functions to let you know when
 * things have changed.
 *
 *  [Inspired by SkateJS.](https://github.com/skatejs/skatejs/blob/5246f85abc166b8ffec3e87ce9c5775c425baf5a/packages/skatejs/src/with-update.js)
 *
 *  NOTE: This mixin defines `attributeChangedCallback`. It is expected you
 *  don't need to use it directly, as this mixin handles calling update for you,
 *  but if you do don't forget to call super.
 *
 * @category mixin
 * @param {Class} [Base=HTMLElement] Optional base class to extend from.
 * @returns {Class}
 *
 * @example
 ```js
import { withUpdate } from '@updater-legacy/components/custom-element';

class MyCustomElement extends withUpdate() {
  // Define a static list of properties that `withUpdate` should manage.
  static props = ['value'];

  static get observedAttributes() {
    return ['name'];
  }

  // The `_state` property is managed by default, intended for internal state.
  // We can set the initial state like this. It will trigger a call to `updated`.
  _state = {
    currentIndex: 0,
  }

  // Define an `updated` method to react to changes to managed properties.
  // This callback is invoked with the current values of all managed properties.
  updated({ _state: { currentIndex }, value, name }) {
    // Good place to render.
  }

  clickHandler(value) {
    // This mixin provides a convenience method for updating internal state.
    // It simply merges the new state object into the old state object
    // (assuming the internal state is stored as an object).
    this.mergeState({ currentIndex: this._state.currentIndex + 1 });
  }
}
 ```
 */
var withUpdate = function withUpdate() {
  var Base =
    arguments.length > 0 && arguments[0] !== undefined
      ? arguments[0]
      : _HTMLElement;
  return (function (_Base) {
    inherits(_class2, _Base);

    function _class2() {
      classCallCheck(this, _class2);

      var _this = possibleConstructorReturn(
        this,
        (_class2.__proto__ || Object.getPrototypeOf(_class2)).call(this)
      );

      _this._updateScheduled = false;
      _this._attrs = {};

      var attrs = _this.constructor.observedAttributes || [];
      var props = ['_state'].concat(_this.constructor.props || []);
      console.assert(
        !attrs.some(function (attr) {
          return props.includes(attr);
        }),
        'observedAttributes and props cannot overlap when using withUpdate(). They must include all unique keys\n          props: ' +
          props +
          '\n          attrs: ' +
          attrs +
          '\n        '
      );
      var initialProps = initializeProps(props, _this);
      _this._props = initializeProps(props);
      _this._attrs = initializeProps(attrs);

      // Create a getter/setter pair for each property name in `props`.
      // When set, we schedule a call to the `updated` callback, if defined.
      // In `updated`, we can react to all recent property changes at once.
      props.forEach(function (prop) {
        Object.defineProperty(_this, prop, {
          enumerable: true,
          get: function get$$1() {
            return _this._props[prop];
          },
          set: function set$$1(newValue) {
            if (newValue !== _this[prop]) {
              _this._scheduleUpdate();
              _this._props[prop] = newValue;
            }
          },
        });

        // Apply "upgradeProperty" workaround, ensuring properties set before
        // the class is constructed work the same as if they were set after.
        // https://developers.google.com/web/fundamentals/web-components/best-practices#lazy-properties
        _this[prop] = initialProps[prop];
      });
      return _this;
    }

    createClass(_class2, [
      {
        key: 'mergeState',
        value: function mergeState(value) {
          this._state = _extends({}, this._state, value);
        },
      },
      {
        key: 'attributeChangedCallback',
        value: function attributeChangedCallback(name, oldVal, newVal) {
          get(
            _class2.prototype.__proto__ ||
              Object.getPrototypeOf(_class2.prototype),
            'attributeChangedCallback',
            this
          ) &&
            get(
              _class2.prototype.__proto__ ||
                Object.getPrototypeOf(_class2.prototype),
              'attributeChangedCallback',
              this
            ).call(this, name, oldVal, newVal);
          this._scheduleUpdate();
          this._attrs[name] = newVal;
        },
      },
      {
        key: '_scheduleUpdate',
        value: function _scheduleUpdate() {
          var _this2 = this;

          if (!this._updateScheduled && this.updated) {
            this._updateScheduled = true;
            var oldProps = _extends({}, this._props, this._attrs);

            Promise.resolve().then(function () {
              _this2._updateScheduled = false;
              _this2.updated(
                _extends({}, _this2._props, _this2._attrs),
                oldProps
              );
            });
          }
        },
      },
    ]);
    return _class2;
  })(Base);
};

/**
 * The `withHTMLComponent` compound mixin combines a set mixins necessary to create a web component with ShadowDOM. It's intended for simple components that don't require complex rendering. It renders the given `html` immediately and relies on manual DOM manipulation for dynamic content.
 *
 * Mixins used:
 * - `withAttributeReflection`
 * - `withLifecycle`
 * - `withShadowDOM`
 * - `withTemplate`
 * - `withUpdate`
 *
 * @category mixin - compound
 * @param {String} styles CSS string that's shimmed for ShadowDOM use and automatically attached to the ShadowDOM for each instance.
 * @param {String} html HTML string that's cloned into a DOM node and automatically attached to the ShadowDOM for each instance.
 * @param {Class} [Base=HTMLElement] Optional base class to extend from.
 * @returns {Class}
 *
 * @example
```js
import { withHTMLComponent } from '@updater-legacy/components/custom-element';
const html = `<div id="container"><input /></div>`;
import styles from './index.css';

class Input extends withHTMLComponent(styles, html)() {
  static props = ['value'];
  static reflectedAttributes = [
    { 
      name: 'disabled',
      boolean: true,
    },
    {
      name: 'type',
    }
  ];

  updated({ value }) {
    this.shadowRoot.querySelector('#input').value = value;
  }
}
 ```
 */
var withHTMLComponent = function withHTMLComponent(styles, html) {
  return function () {
    var Base =
      arguments.length > 0 && arguments[0] !== undefined
        ? arguments[0]
        : _HTMLElement;
    return (function (_withShadowDOM) {
      inherits(_class, _withShadowDOM);

      function _class() {
        classCallCheck(this, _class);

        var _this = possibleConstructorReturn(
          this,
          (_class.__proto__ || Object.getPrototypeOf(_class)).call(this)
        );

        _this.shadowRoot.appendChild(_this._styles);
        _this.shadowRoot.appendChild(_this._template);
        return _this;
      }

      return _class;
    })(
      withShadowDOM(styles)(
        withTemplate(html)(
          withUpdate(withAttributeReflection(withLifecycle(Base)))
        )
      )
    );
  };
};

/**
 * The `withTextComponent` compound mixin is intended for the very simplest components that don't require styles or markup.
 *
 * Mixins used:
 * - `withAttributeReflection`
 * - `withLifecycle`
 * - `withUpdate`
 *
 * @category mixin - compound
 * @param {Class} [Base=HTMLElement] Optional base class to extend from.
 * @returns {Class}
 *
 * @example
```js
import { withTextComponent } from '@updater-legacy/components/custom-element';

class USCurrencyFormatter extends withTextComponent() {
  static props = ['value'];
  static reflectedAttributes = [
    { 
      name: 'disabled',
      boolean: true,
    },
    {
      name: 'type',
    }
  ];

  updated({ value }) {
    this.textContent = `$${value}`;
  }
}
 ```
 */
var withTextComponent = function withTextComponent() {
  var Base =
    arguments.length > 0 && arguments[0] !== undefined
      ? arguments[0]
      : _HTMLElement;
  return (function (_withUpdate) {
    inherits(_class, _withUpdate);

    function _class() {
      classCallCheck(this, _class);
      return possibleConstructorReturn(
        this,
        (_class.__proto__ || Object.getPrototypeOf(_class)).apply(
          this,
          arguments
        )
      );
    }

    return _class;
  })(withUpdate(withAttributeReflection(withLifecycle(Base))));
};

var _templateObject = taggedTemplateLiteral(['', ''], ['', '']);

/**
 * The `withViewComponent` compound mixin is intended for components requiring complex rendering that is difficult to achieve using manual DOM manipulation. To this end, it provides a `render` method (currently backed by [`hyperHTML`](https://github.com/WebReflection/hyperHTML)).
 *
 * **Mixins**
 * - `withAttributeReflection`
 * - `withLifecycle`
 * - `withShadowDOM`
 * - `withUpdate`
 *
 * @category mixin - compound
 * @param {String} styles CSS string that's shimmed for ShadowDOM use and
 * automatically attached to the ShadowDOM for each instance.
 * @param {Class} [Base=HTMLElement] Optional base class to extend from.
 * @returns {Class}
 *
 * @example
```js
import { withViewComponent } from '@updater-legacy/components/custom-element';
import styles from './index.css';

class List extends withViewComponent(styles)() {
  static props = ['value'];
  static reflectedAttributes = [
    { 
      name: 'disabled',
      boolean: true,
    },
    {
      name: 'type',
    }
  ];

  updated({ value }) {
    this.render`
      <ul>
        ${value.map({ id, label }) =>
          // As a convenience, this mixin provides a specialization of `hyperHTML`'s
          // `wire` method, with the added ability to re-use DOM nodes by string id.
          // It's useful when creating lists.
          this.wire(id)`<li>${label}</li>`
        )}
      </ul>
    `;
  }
}
 ```
 */
var withViewComponent = function withViewComponent(styles) {
  return function () {
    var Base =
      arguments.length > 0 && arguments[0] !== undefined
        ? arguments[0]
        : _HTMLElement;
    return (function (_withShadowDOM) {
      inherits(_class2, _withShadowDOM);

      function _class2() {
        classCallCheck(this, _class2);

        // Calling `hyper` with a template string will replace whatever's
        // in the `shadowRoot` with DOM nodes created by `hyperHTML`.
        var _this = possibleConstructorReturn(
          this,
          (_class2.__proto__ || Object.getPrototypeOf(_class2)).call(this)
        );

        _this._wires = {};
        var hyper = bind(_this.shadowRoot);
        var styles = wire()(_templateObject, _this._styles);

        var stringsWrapper = [''];

        // Wrap `hyper` to automatically insert ShadowDOM CSS before the
        // generated DOM so that we don't have to do so manually.
        _this.render = function (strings) {
          for (
            var _len = arguments.length,
              expressions = Array(_len > 1 ? _len - 1 : 0),
              _key = 1;
            _key < _len;
            _key++
          ) {
            expressions[_key - 1] = arguments[_key];
          }

          // If the `strings` array passed to `hyper` isn't the same instance
          // every time, DOM node caching doesn't work.
          stringsWrapper.splice.apply(
            stringsWrapper,
            [1, 0].concat(toConsumableArray(strings))
          );
          hyper.apply(
            hyper,
            [stringsWrapper].concat([styles].concat(expressions))
          );
        };
        return _this;
      }

      /**
       * Specialized version of `hyperHTML`s `wire` method, supporting string ids
       * to cache DOM nodes for re-use. Useful for creating lists.
       * https://github.com/WebReflection/hyperHTML/issues/93
       *
       * @param {String} [id] Optional string id used to cache and re-use DOM nodes.
       * @return {Function} Tag function accepting a hyperHTML template string.
       *
       * @ignore (Hide from generated docs)
       */

      createClass(_class2, [
        {
          key: 'wire',
          value: function wire$$1(id) {
            return id ? this._wires[id] || (this._wires[id] = wire()) : wire();
          },
        },
        {
          key: 'disconnectedCallback',
          value: function disconnectedCallback() {
            get(
              _class2.prototype.__proto__ ||
                Object.getPrototypeOf(_class2.prototype),
              'disconnectedCallback',
              this
            ) &&
              get(
                _class2.prototype.__proto__ ||
                  Object.getPrototypeOf(_class2.prototype),
                'disconnectedCallback',
                this
              ).call(this);

            // Clear `wire` cache to avoid memory leaks.
            this._wires = {};
          },
        },
      ]);
      return _class2;
    })(
      withShadowDOM(styles)(
        withUpdate(withAttributeReflection(withLifecycle(Base)))
      )
    );
  };
};

export {
  withAttributeReflection,
  withLifecycle,
  withShadowDOM,
  shimStyles,
  withTemplate,
  withUpdate,
  withHTMLComponent,
  withTextComponent,
  withViewComponent,
};
